import WebcamModule from './Module'
import { IUseWebCam } from './types'

const useWebcam: IUseWebCam = (started: boolean, audio: boolean, video: boolean, onReady?: () => void) => {
  if (WebcamModule && !WebcamModule.ready && !started) {
    WebcamModule.init(audio, video)
      .then(result => {
        if (result && onReady && 'function' == typeof onReady) onReady()
      })
      .catch(() => {
        // console.log('error')
      })
  }
  return WebcamModule
}

export default useWebcam
